import { combineReducers } from "redux";
import { connectRouter } from 'connected-react-router'

import { requests } from "@defi/core-auth";
import loginHelpText from "./loginHelpText";
import mfa from "./mfa";

export default (history) => combineReducers({
  router: connectRouter(history),
  requests,
  loginHelpText,
  mfa,
});
